export default "__VITE_ASSET__0ZmEYUkw__"